<template>
  <div>
    <el-table :data="orderList"  size="small" border>
      <el-table-column prop="id"  label="订单ID" fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
         
        </template>
      </el-table-column>

      <!-- <el-table-column prop="fromUserId" label="转出账号"></el-table-column> -->
      <el-table-column prop="userId" label="转入账号"></el-table-column>
      <el-table-column prop="coin" label="币种"></el-table-column>
      <el-table-column prop="availableChange" label="数量"></el-table-column>
      <el-table-column prop="frozeChange" label="冻结数量"></el-table-column>
      <el-table-column prop="availableChangeBefore" label="转入前金额"></el-table-column>
      <el-table-column prop="availableAfter" label="转入后金额"></el-table-column>
      <!-- <el-table-column prop="messageType" label="messageType"></el-table-column> -->
      <el-table-column prop="type" label="订单类型">
        <template slot-scope="scope">
         <span v-if="scope.row.type=='WITHDRAW'">提现</span>
         <span v-else-if="scope.row.type=='DEPOSIT'">充值</span>
         <span v-else-if="scope.row.type=='C2C_PROCESS_ORDER'">C2C成交</span>
         <span v-else-if="scope.row.type=='C2C_PLACE_ORDER'">C2C交易下单</span>
         <span v-else-if="scope.row.type=='CANCEL_WITHDRAW'">取消提现</span>
         <span v-else-if="scope.row.type=='DEPOSITE_INTERNAL_TRANSFER'">内部转账</span>
         <span v-else-if="scope.row.type=='CREATE_TRADE'">下单冻结</span>
         <span v-else-if="scope.row.type=='DEAL_FEE_TO_ACCUMULATED'">手续费</span>
         <span v-else-if="scope.row.type=='TRADE_DEAL'">订单成交</span>
         <span v-else-if="scope.row.type=='CANCEL_TRADE'">撤销订单</span>
         <span v-else-if="scope.row.type=='exchange'">划转</span>
         <span v-else>虚增</span>
        </template>
      </el-table-column>

      
      <!-- <el-table-column prop="orderId"  label="订单号" fixed>
        <template slot-scope="scope">{{
          scope.row.orderId
        }}</template>
      </el-table-column> -->
      <el-table-column prop="createdTime"  label="创建时间" fixed>
        <template slot-scope="scope">{{
          new Date(scope.row.createdTime).toLocaleString()
        }}</template>
      </el-table-column>
      
    </el-table>
    <pagination
      :size="size"
      :total="totalCount"
      :page="page"
      @pageChanged="pageChanged"
    ></pagination>
   
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'FinanceBillList',

  data() {
    return {
      page:1,size:25,
    };
  },
  components: {
    Pagination,
    
  },
  methods: {
    ...mapActions('financeBill', [
      'updateDividendStatus',
      'updateMark'
    ]),
    ...mapMutations('financeBill', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail'
    ]),
    pageChanged(e) {
      this.page=e.page
      this.size=e.size
      this.$emit('refresh', {page:this.page,size:this.size});
    },
    handleDel(row){
      console.log(row);
    },
    handleUpdate(selected) {
      this.setUserinfoDetail(selected);
      this.setUserinfoDetailDialogVisible(true);
    },
   
  },
  computed: {
    ...mapGetters('financeBill', ['userList',]),
    ...mapState('financeBill', [
      'pagination',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible','blockInfoList','orderList'
    ])
  }
};
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.red {
  color: red;
  font-weight: bold;
}
</style>
